<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-size-100">
            <h4>{{translate(locale.editChannel)}}</h4>
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

        <div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
            <md-card>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                            <div class="md-layout">
                                <div class="md-layout-item md-small-size-100 md-size-100 text-right">
                                    <span class="late">{{translate(locale.required)}}</span>
                                </div>
                                <div
                                    class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
                                    <md-field>
                                        <label>{{translate(locale.channelName)}} *</label>
                                        <md-input type="text" v-model="channel.name"></md-input>
                                    </md-field>
                                </div>
                                <div
                                    class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-20">
                                    <md-field>
                                        <label>{{translate(locale.channelCode)}} *</label>
                                        <md-input type="text" v-model="channel.slug"></md-input>
                                    </md-field>
                                </div>
                                <div
                                    class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-30">
                                    <md-field>
                                        <label>{{translate(locale.clientTelegramBotToken )}} *</label>
                                        <md-input type="text" v-model="channel.telegram_bot_token"></md-input>
                                    </md-field>
                                </div>
                                <div
                                    class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
                                    <md-field>
                                        <label>{{translate(locale.clientTelegramChatId)}} *</label>
                                        <md-input type="text" v-model="channel.telegram_chat_id"></md-input>
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
									<h4 class="order-title" style="display: flex;align-items: center;">
									   <b>{{translate(locale.notificationSetting)}}</b>
									</h4>
								</div>
                                <div
                                    class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                                    <md-checkbox v-model="channel.notification_normal_log" class="md-primary"><span
                                            style="color:green; font-size: 20px;">&#10687;</span>
                                        {{translate(locale.sendNotificationNormalLog)}}</md-checkbox>
                                    <md-checkbox v-model="channel.notification_warning_log" class="md-primary"><span
                                            style="color:orange; font-size: 20px;">&#10687;</span>
                                        {{translate(locale.sendNotificationWarningLog)}}</md-checkbox>
                                    <md-checkbox v-model="channel.notification_critical_log" class="md-primary"><span
                                            style="color:red; font-size: 20px;">&#10687;</span>
                                        {{translate(locale.sendNotificationCriticalLog)}}</md-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-100 text-right">
                            <span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
                        </div>
                        <div
                            class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                            <md-button class="md-raised md-primary"
                                @click="update()">{{translate(locale.editChannel)}}</md-button>
                        </div>
                    </div>

                </md-card-content>
            </md-card>
        </div>
    </div>

    </div>

</template>

<script>
    import { Datetime } from 'vue-datetime';
    export default {
        components: { Datetime },
        created() {
            this.getChannel();
        },

        data() {
            return {
                loaded: false,
                channel: {
                    name: "",
                    slug: "",
                    telegram_bot_token: "",
                    telegram_chat_id: "",
                    notification_normal_log: "",
                    notification_warning_log: "",
                    notification_critical_log: ""
                },
                errors: []
            }
        },
        methods: {
            getChannel() {
				this.$http.get(this.config.api + "/admin/client/get_channel/" + this.$route.params.hash).then(data => {
					let channel = data.body.data.channel;
					let notification = data.body.data.notification;

                    this.channel.name = channel.name;
                    this.channel.slug = channel.slug;
                    this.channel.telegram_bot_token = channel.telegram_bot_token;
                    this.channel.telegram_chat_id = channel.telegram_chat_id;

                    for(let i =0; i<notification.length; i++) {
                        if(notification[i].level_id == 1) this.channel.notification_normal_log = "on";
                        if(notification[i].level_id == 2) this.channel.notification_warning_log = "on";
                        if(notification[i].level_id == 3) this.channel.notification_critical_log = "on";
                    }

					this.loaded = true;
				});
			},
            update() {

                if (!this.checkValidation()) {
                    this.$notification.notify({ message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger' });
                    return;
                }

                this.$http.post(this.config.api + "/admin/client/update_channel", {
                    hash: this.$route.params.hash,
                    channel: this.channel
                }).then(res => {
                    if (res.body.status == 'success') {
                        this.$notification.notify({
                            message: "You have updated a channel successfully.||អ្នកបានកែប្រែឆានែលដោយជោគជ័យ។",
                            icon: 'check_circle',
                            type: 'success'
                        });
                        this.$router.go(-1);
                    }
                })
            },
            checkValidation() {
                this.errors = [];

                if (String(this.channel.name).length < 3) this.errors.push("Please fill in Name.||សូមបំពេញឈ្មោះ។");
                if (String(this.channel.slug).length < 3) this.errors.push("Please fill in Slug.||សូមបំពេញឈ្មោះប្រព័ន្ធបុត្រសម្ព័ន្ធ។");
                if (String(this.channel.telegram_bot_token).length < 3) this.errors.push("Please fill in Telegram Bot Token.||សូមបំពេញលេខកូដតេឡេក្រាម Bot Token។");
                if (String(this.channel.telegram_chat_id).length < 3) this.errors.push("Please fill in Telegram Group ID.||សូមបំពេញតេឡេក្រាមក្រុម ID។");

                if (this.errors.length == 0) return true;
                else return false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Clients/EditChannel.vue